export default {
    isTabSelect: state => state.isTabSelect,
    isListTab: state => state.isListTab,
};
